import styled from 'react-emotion';
import UnstyledConversationIcon from '../../common/ConversationIcon.container';

export const ConversationIcon = styled(UnstyledConversationIcon)``;
